import { http, createConfig, createStorage } from 'wagmi';
import { galactica, galacticaCassiopeia } from './chains';

export const config = createConfig({
  chains: [galactica, galacticaCassiopeia],
  transports: {
    [galactica.id]: http(),
    [galacticaCassiopeia.id]: http(),
  },
  storage: createStorage({ storage: localStorage }),
});

declare module 'wagmi' {
  interface Register {
    config: typeof config;
  }
}
